import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MediaPreviewData {
  url: string;
  fileName: string;
  fileType: string;
}

@Component({
  selector: 'app-media-preview-dialog',
  standalone: false,
  templateUrl: './media-preview-dialog.component.html',
  styleUrls: ['./media-preview-dialog.component.scss'],
})
export class MediaPreviewDialogComponent {
  readonly url: string;

  @ViewChild('imageMain') imageMainRef?: ElementRef<HTMLElement>;

  imageFrameWidth = '100%';
  imageFrameHeight = '100%';

  constructor(
    public dialogRef: MatDialogRef<MediaPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MediaPreviewData
  ) {
    const separator = data.url.includes('?') ? '&' : '?';
    this.url = `${data.url}${separator}t=${Date.now()}`;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onImageLoad(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (!img.naturalWidth || !img.naturalHeight) return;

    const container = this.imageMainRef?.nativeElement;
    if (!container) return;

    const maxW = container.clientWidth;
    const maxH = container.clientHeight;
    const ratio = img.naturalWidth / img.naturalHeight;

    let w = maxW;
    let h = w / ratio;
    if (h > maxH) {
      h = maxH;
      w = h * ratio;
    }

    this.imageFrameWidth = `${Math.floor(w)}px`;
    this.imageFrameHeight = `${Math.floor(h)}px`;
  }

  isImage(): boolean {
    const type = this.data.fileType;
    if (type.startsWith('image/')) return true;
    if (type.startsWith('video/') || type.toUpperCase().includes('VIDEO')) return false;
    return type.length > 0;
  }

  isVideo(): boolean {
    const type = this.data.fileType;
    return type.startsWith('video/') || type.toUpperCase().includes('VIDEO');
  }
}
